import axios from '../../../core/services/axios';

export const getLocations = (params, cancelToken) => axios.get('/api/locations', { params, cancelToken });
export const deleteLocation = (id) => axios.delete(`/api/locations/${id}`);
export const createLocation = (data) => axios.post('/api/locations', data);
export const updateLocation = (id, data) => axios.put(`/api/locations/${id}`, data);
